import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import ThesaurusGroupsRoot from './ThesaurusGroups/ThesaurusGroupsRoot';
import SelectedSearchItems from './SelectedSearchItems';
import TreeViewDialogFooter from './TreeViewDialogFooter';
import SelectedItemsCount from '../SelectedItemsCount';

import './TreeViewDialog.scss';

function TreeViewDialog(props) {
  const { filter, selectedCount } = props;
  const title = filter?.get('title');

  return filter ? (
    <GeneralDialogLayout
      {...props}
      contentClassName="tree-view-dialog-content"
      headerClassName="tree-view-dialog-header"
      header={
        <h4 className="tree-view-dialog-header-h4">
          {title}
          <SelectedItemsCount count={selectedCount} />
        </h4>
      }
      footerClassName="tree-view-dialog-footer"
      footer={<TreeViewDialogFooter {...props} />}>
      <ThesaurusGroupsRoot {...props} />
      <SelectedSearchItems {...props} />
    </GeneralDialogLayout>
  ) : null;
}

TreeViewDialog.propTypes = {
  filter: PropTypes.instanceOf(Map),
  expandSearchOptions: PropTypes.bool.isRequired,
  onToggleSearchOptions: PropTypes.func.isRequired,
  onClickThesaurusItem: PropTypes.func.isRequired,
};

export default TreeViewDialog;
